import { useV1MarketplaceCatalogFamiliesList } from "@/api/generated/v1/v1";
import type { CatalogFamily } from "@/api/generated/models";
import { PageBanner } from "@/shared/components/PageBanner";
import { Link } from "react-router-dom";

export function CatalogListPage() {
  const { data, isLoading, isError } = useV1MarketplaceCatalogFamiliesList();
  const catalogs = data?.results ?? [];

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="کاتالوگ‌ها"
        subtitle="مدیریت و مشاهده کاتالوگ‌های محصولات و خدمات"
        icon="📚"
        helpLink="/help/marketplace/catalogs"
      >
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          <Link
            to="/marketplace/catalog/new"
            style={{
              padding: "0.6rem 1.25rem",
              borderRadius: "12px",
              background: "#ffffff",
              color: "#007270",
              fontWeight: 700,
              fontSize: "0.9rem",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              transition: "all 0.2s ease",
              textDecoration: "none"
            }}
          >
            <span>➕</span>
            <span>ایجاد کاتالوگ</span>
          </Link>
        </div>
      </PageBanner>

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
        {isLoading && <p>در حال بارگذاری...</p>}
        {isError && <p style={{ color: "red" }}>خطا در دریافت کاتالوگ‌ها.</p>}

        {!isLoading && !isError && (
          <div className="table-container" style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", textAlign: "right", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid var(--glass-border)" }}>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>شناسه</th>
                  <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>کد</th>
                </tr>
              </thead>
              <tbody>
                {catalogs.length === 0 && (
                  <tr>
                    <td colSpan={2} style={{ padding: "2rem", textAlign: "center", color: "var(--color-text-muted)" }}>
                      هیچ کاتالوگی یافت نشد.
                    </td>
                  </tr>
                )}
                {catalogs.map((catalog: CatalogFamily) => (
                  <tr key={catalog.id} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                    <td style={{ padding: "1rem", fontFamily: "monospace" }}>{catalog.id}</td>
                    <td style={{ padding: "1rem" }}>{catalog.code || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
